export const VC_TO_CREATE = 'TO CREATE';
export const VC_CREATED = 'CREATED';
export const VC_SENT = 'SENT';
export const VC_EXPIRED = 'EXPIRED';
export const VC_REDEEMED = 'REDEEMED';
